import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import FeaturedArticles from './components/FeaturedArticles';
import CommunityStats from './components/CommunityStats';
import CTASection from './components/CTASection';
import { generateOrganizationSchema, generateWebsiteSchema } from '@/mocks/schema';

const BASE_URL = 'https://yuriclub.cn';

export default function Home() {
  const pageTitle = '百合会官方落地页 | 加入百合会社群';
  const pageDesc = '百合会是专为百合文化爱好者打造的核心聚集地，汇聚百合漫画、百合动漫、百合小说等优质内容与同好交流。加入百合会，与志同道合的伙伴一起探索女女情感故事的无限魅力，发现最新百合作品推荐与活动资讯。';
  const pageKeywords = '百合会,百合会社群,百合漫画推荐,百合动漫作品,百合小说,百合文化爱好者,百合CP,女女恋爱故事';

  const jsonLd = [
    generateOrganizationSchema(),
    generateWebsiteSchema(),
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: pageTitle,
      description: pageDesc,
      url: BASE_URL,
      isPartOf: {
        '@type': 'WebSite',
        name: '百合会',
        url: BASE_URL,
      },
    },
  ];

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl={BASE_URL}
        ogImage="https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20anime%20style%20illustration%20of%20two%20girls%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20white%20color%20palette%2C%20warm%20spring%20atmosphere%2C%20clean%20composition&width=1200&height=630&seq=yuri-og-home&orientation=landscape"
        jsonLd={jsonLd}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryShowcase />
        <FeaturedArticles />
        <CommunityStats />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}